import * as yup from "yup";

const addAndChangeSchema = (translate: Function) => yup.object().shape({
	efa011Descricao: yup.string().required(translate("Descrição é requerido")),
	efa011Ativo: yup.string().oneOf(["S", "N"]),
	eftba021:  yup.array().of(yup.string())
		.required(translate("É necessario inserir ao menos uma origem de dados"))
});

export default  addAndChangeSchema;
